import { render } from "./Article.vue?vue&type=template&id=131b822a&scoped=true"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"

import "./Article.vue?vue&type=style&index=0&id=131b822a&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131b822a"]])

export default __exports__